import { render, staticRenderFns } from "./PollCard.vue?vue&type=template&id=3049faae&scoped=true&"
import script from "./PollCard.vue?vue&type=script&lang=ts&"
export * from "./PollCard.vue?vue&type=script&lang=ts&"
import style0 from "./PollCard.vue?vue&type=style&index=0&id=3049faae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3049faae",
  null
  
)

export default component.exports